import { gastoApi } from '../../utils/api';
import { getListDataAction } from '../../utils/DataAction';

export const getAll = getListDataAction({
  dataName: 'GASTO_TIPO',
  api: gastoApi,
  relUrl: 'getAllTipos',
});
